import { Environment } from '@app/shared/models';

export const environment: Environment = {
    appId: 'admin',
    production: true,
    instrumentationKey: '080d58e7-c204-4ae0-9158-bbac713ffebf',
    metricInstrumentationKey: 'c81c4cf4-aac9-4192-992b-d68a959305ec',
    searchIndexQueueName: 'searchindex',
    sendToEmail: 'lifestyledesignmentor@gmail.com',

    appUrl: location.origin,

    cdnUrl: 'https://cdn.shareablelink.online',
    rapidApiUrl: 'https://api.shareablelink.online/func-api-auth',
    serverUrl: `https://api.shareablelink.online`,
    proxyServerUrl: `https://api.shareablelink.online`,
    fpEndpointUrl: `https://shareablelink.online`,
    fpjsToken: 'icVKtNvtbIY3JkgZyj6w',

    activityReportInSec: 60,
    inactivityTimeoutInSec: 604800, //7 days
    debug: false,
    autoUpdate: true,
    insightsEnabled: true,

    blobStorageUrl: '',
    privateContainerName: 'production-private',
    publicContainerName: 'production-public',

    sourceStorageSasUri: 'https://storageazureshare.blob.core.windows.net/',
    destinationStorageSasUri: 'https://shareablelink.blob.core.windows.net/',

    buildVersion: '1.0.195',
    buildDate: '2025-07-26T16:41:55+00:00',
    buildCommit: 'a86ddee095e1e29f836cff8a2dd887862f4e093a'
};
